import { get } from "@/services/axiosUitils";

const basePath = "/tenant-core/activity-logs";

class ActivityLogsService {
  /**
   * Get all activity logs
   */
  getAllActivityLogs = async ({
    page,
    pageSize,
    start_date,
    end_date,
    activity_type,
    search,
  }: {
    page: number;
    pageSize: number;
    start_date?: string;
    end_date?: string;
    activity_type?: string;
    search?: string;
  }): Promise<any> => {
    const params: any = {
      page,
      page_size: pageSize,
    };

    if (start_date) {
      params.start_date = start_date;
    }
    if (end_date) {
      params.end_date = end_date;
    }
    if (activity_type) {
      params.activity_type = activity_type;
    }
    if (search) {
      params.search = search;
    }

    const response = await get<any>(`${basePath}/`, {
      params,
    });

    return response;
  };

  /**
   * Get activity log by ID
   */
  getActivityLogById = async (id: string): Promise<any> => {
    return await get<any>(`${basePath}/${id}/`);
  };
}

export default new ActivityLogsService();
